// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  UptimeImageOverlay
} from '@uptime/uptime-component';
import { useSelector } from 'react-redux';
import { useUserData } from 'hooks';
import { useContentLanguage } from 'store';
import { mapLanguage } from 'utils/mapLanguage';
import { useTheme } from 'styled-components';
import DefaultUptimeTheme from 'utils/lumosTheme';
import { RootState } from 'redux/store';
import { ChatPath } from 'utils/routes';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n';
import {
  addDecodedScriptToHead,
  checkInTeams,
  handleNavigateStaticTab,
  handlePatternURL,
  checkSupportedCountry,
} from 'utils/function';
import HTMLReactParser from 'html-react-parser';
import { useChatWidget } from 'containers/ChatWidgetContainer';

export const openChat = async () => {
  await window.widget.openBubbleChat();
};
const start = async () => {
  await window.widget.openChat();
};
export const startChat = async () => {
  await openChat();
  await start();
};
export const minimizeChat = async () => {
  await window.widget.minimizeChat();
};
export const maximizeChat = async () => {
  await window.widget.maximizeChat();
};
const closeChat = async () => {
  await window.widget.closeChat();
};
const closeConfirmChat = async () => {
  await window.widget.closeConfirmChat();
};
const resetChat = async () => {
  await window.widget.resetChat();
};
export const endChat = async () => {
  await resetChat();
  await closeChat();
  await closeConfirmChat();
};
export const sendMessage = async (message: string) => {
  await window.widget.sendMessage(message);
};

export const queueMessage = (message: string) => {
  window.widget.queueMessage(message);
};

export const setChatConfig = (config?: any) => {
  if (!!window.widget?.getConfiguration)
  {
    const currentConfig = window.widget.getConfiguration();
    window.widget.setConfiguration({
      ...currentConfig,
      ...config
    });
  }
};
export const isChatOpen = () => {
  return !document.querySelector('#widget_bubble');
};
export const setColorTheme = (themeColor: any) => {
  window.widget.setColorTheme(themeColor);
};
export const setHeaderLogo = (logo: any) => {
  window.widget.setHeaderLogo(logo);
};
export const setHeroContent = (
  preTitle: string,
  title: string,
  description: string,
  startButton: string,
  exitButton: string,
  endTitle: string,
  endDescription: string,
  cancelEnd: string,
  confirmEnd: string,
) => {
  window.widget.setHeroContent({
    preTitle,
    title,
    description,
    startButton,
    exitButton,
    endTitle,
    endDescription,
    cancelEnd,
    confirmEnd,
  });
};
export const setHeroLogo = (logo: any) => {
  window.widget.setHeroLogo(logo);
};
export const setBubbleLogo = (logo: any) => {
  window.widget.setBubbleLogo(logo);
};

export const setChatLanguage = async (language: string) => {
  await window.widget?.setChatLanguage(language);
};

export const initChatMessage = async (isSendMessage: any, message: string, initialMessage: string) => {
  if (isSendMessage) {
    queueMessage(message);
  } else {
    setChatConfig({initialMessage: message});
  }
  await startChat();
  setChatConfig({initialMessage: initialMessage});
};

interface IChatWidgetComponentProps {
  enabled: boolean;
}

const ChatWidgetComponent: React.FC<IChatWidgetComponentProps> = (props) => {
  const { enabled } = props;
  const { jsLoaded, setJsLoaded } = useChatWidget();
  const history = useHistory();
  const [imageUrl, setImageUrl] = useState('');
  const [imageOverlayOpen, setImageOverlayOpen] = useState(false);
  const [globalContentLanguage,] = useContentLanguage();
  const currentUser = useUserData();
  const [asdChatConfig, setAsdChatConfig] = useState({});
  const { generalConfig } = useSelector((state: RootState) => state.configReducer);
  const [configChat, setConfigChat] = useState<any>();
  const languageData = generalConfig?.supportLanguage;
  const currentLanguage = languageData && languageData?.data?.find((lang)=>lang.code === globalContentLanguage);
  const [listenerAdded, setListenerAdded] = useState(false);
  const theme = useTheme() as typeof DefaultUptimeTheme;
  const { t } = useTranslation('asdChatWidget');
  const { pathname, search } = useLocation();
  const queryUserByUserName = generalConfig?.queryUserByUserName ?? false;
  const searchParams = new URLSearchParams(search);
  const [message, setMessage] = useState(searchParams.get('message'));
  const widget = document.querySelector('#widget');
  const draggableWidget = generalConfig?.asdChatWidget?.draggableWidget;

  //Support Country Feature
  const unsupportedCountriesData = generalConfig?.asdChatWidget?.unsupportedCountries ?? [];
  const currentUserCountryCode = currentUser?.country;
  const isSupportedCountry = checkSupportedCountry(unsupportedCountriesData, currentUserCountryCode);

  const addCssUrl = (href, onload) => {
    const css = document.createElement('link');
    css.href = href;
    css.rel = "stylesheet";
    document.getElementsByTagName('head')[0].appendChild(css);
    if(onload)
    {
      css.onload = onload;
    }
  };
  const addScriptUrl = (src, onload) => {
    const script = document.createElement('script');
    script.src = src;
    script.type = "module";
    script.crossOrigin = true;
    document.getElementsByTagName('head')[0].appendChild(script);
    if(onload)
    {
      script.onload = onload;
    }
  };
  const addScriptBarista = (snippet, onload) => {
    HTMLReactParser(snippet, {
      replace: function (domNode) {
        if (domNode.type === 'script') {
          const script = document.createElement("script");

          script.src = domNode.attribs.src;
          script.setAttribute("data-color", `${domNode.attribs["data-color"] ?? "#0082C8"}`);
          script.setAttribute("data-position", `${domNode.attribs["data-position"] ?? "bottom left"}`);

          if (onload) {
            script.onload = onload;
          }

          document.body.appendChild(script);
        }
      }
    });
  };

  useEffect(()=> {
    if(!generalConfig.asdChatWidget || !enabled || !isSupportedCountry) return;
    setConfigChat(generalConfig?.asdChatWidget?.initialConfig);
    setAsdChatConfig(generalConfig.asdChatWidget);
    handleWidgetDraggable();
  },[generalConfig.asdChatWidget, enabled]);

  useEffect(()=>{
    if(asdChatConfig?.styleCssUrl){
      addCssUrl(asdChatConfig.styleCssUrl, () => {
        if(asdChatConfig?.scriptJsUrl){
          addScriptUrl(asdChatConfig?.scriptJsUrl, () => {
            setJsLoaded(true);
          });
        };
      });
    };
  },[asdChatConfig.styleCssUrl, asdChatConfig?.scriptJsUrl]);

  useEffect(() => {
    if (generalConfig?.baristaWidget?.snippet && !!generalConfig?.baristaWidget?.enabled) {
      const snippet = atob(generalConfig?.baristaWidget?.snippet);
      addScriptBarista(snippet);
    }
  }, [generalConfig?.baristaWidget]);

  useEffect(() => {
    const userEmail = currentUser?.tokenEmail ?? currentUser?.email;
    if(userEmail && jsLoaded && currentLanguage?.code){
      // set initial config for chat widget
      setChatConfig({
        chatLanguage: mapLanguage(currentLanguage?.code),
        firstName: currentUser?.first_name,
        lastName: currentUser?.last_name,
        fullName: currentUser?.name,
        emailId: queryUserByUserName? currentUser?.user_name : userEmail,
        customUserAttribute2: 'Not passed',
        customUserAttribute3: false,
        customUserAttribute4: 'password',
        languageId: currentLanguage?.name,
        snowSysId: currentUser?.uid,
        initialMessage: asdChatConfig?.initialChat || ' ',
        autoclose: asdChatConfig?.isAutoClose ? 'true':'false'
      });
      if(theme?.uptimeColors?.thirdPartyColors?.chatASD){
        setColorTheme({
          heroLogoColor: theme.uptimeColors.thirdPartyColors.chatASD.heroLogoColor,
          bubbleBackgroundColor: theme.uptimeColors.thirdPartyColors.chatASD.bubbleBackgroundColor,
          bubbleIconColor: theme.uptimeColors.thirdPartyColors.chatASD.bubbleIconColor,
          headerLogoColor: theme.uptimeColors.thirdPartyColors.chatASD.headerLogoColor,
          headerBackgroundColor: theme.uptimeColors.thirdPartyColors.chatASD.headerBackgroundColor,
          headerActionsButtons: theme.uptimeColors.thirdPartyColors.chatASD.headerActionsButtons,
          scrollbarColor: theme.uptimeColors.thirdPartyColors.chatASD.scrollbarColor,
          sendButtonColor: theme.uptimeColors.thirdPartyColors.chatASD.sendButtonColor,
          actionCardColor: theme.uptimeColors.thirdPartyColors.chatASD.actionCardColor,
          startChatButtonColor: theme.uptimeColors.thirdPartyColors.chatASD.startChatButtonColor,
          closeConfirmChatButtonColor: theme.uptimeColors.thirdPartyColors.chatASD.closeConfirmChatButtonColor,
          closeCancelChatButtonColor: theme.uptimeColors.thirdPartyColors.chatASD.closeCancelChatButtonColor,
          linkColor: theme.uptimeColors.thirdPartyColors.chatASD.linkColor,
          widgetFontFamily: theme.uptimeColors.thirdPartyColors.chatASD.widgetFontFamily,
        });
      }
      setChatLanguage(mapLanguage(currentLanguage?.code));
      setHeroContent(
        configChat?.heroContent?.preTitle || t('asdChatWidget:preTitle'),
        configChat?.heroContent?.title || t('asdChatWidget:title'),
        configChat?.heroContent?.description || t('asdChatWidget:description'),
        configChat?.heroContent?.startButton || t('asdChatWidget:startButton'),
        configChat?.heroContent?.exitButton || t('asdChatWidget:exitButton'),
        configChat?.heroContent?.endTitle || t('asdChatWidget:endTitle'),
        configChat?.heroContent?.endDescription || t('asdChatWidget:endDescription'),
        configChat?.heroContent?.cancelEnd || t('asdChatWidget:cancelEnd'),
        configChat?.heroContent?.confirmEnd || t('asdChatWidget:confirmEnd'),
      );
    
      if(configChat){
        if(configChat.headerLogo){
          setHeaderLogo(configChat.headerLogo);
        }
        if(configChat.bubbleLogo){
          setBubbleLogo(configChat.bubbleLogo);
        }
        if(configChat.heroLogo){
          setHeroLogo(configChat.heroLogo);
        }
      }
    };
  },[currentUser?.email, jsLoaded, currentLanguage?.code, asdChatConfig?.initialChat, configChat, i18n.language]);

  useEffect(() => {
    const transcript = document.querySelector('#widget');

    if (!transcript || listenerAdded || !generalConfig?.asdChatWidget?.linkConfig) return;

    // handle open KB in current enviroment
    transcript.addEventListener('click', (event) => {
      if ((event.target.tagName === 'STRONG' && event.target.parentElement.tagName === 'A') || event.target.tagName === 'A') {
        event.preventDefault();

        const link = event.target.tagName === 'A' ? event.target : event.target.parentElement;
        const href = link.getAttribute('href');
        handlePatternURL(generalConfig?.asdChatWidget?.linkConfig, href, history);
      }
      if (event.target.tagName === 'IMG') {
        event.preventDefault();

        const src = event.target.getAttribute('src');
        setImageUrl(src);
        setImageOverlayOpen(true);
      }
    });
    setListenerAdded(true);

    return () => {
      window.removeEventListener('click', transcript);
    };
  }, [window.widget, generalConfig?.asdChatWidget?.linkConfig]);

  const handleClickChat = async () => {
    await openChat();   
  };

  const handleSendMessage = async (message: string) => {
    await start();
    await sendMessage(message);  
  };

  useEffect(() => {
    if(!asdChatConfig?.openChatWithDeepLink) return;   
    if(configChat && jsLoaded) {
      setMessage(searchParams.get('message'));
      if (pathname === ChatPath) {
        handleClickChat(); 
        if (message) {     
          handleSendMessage(message);           
        };          
      };
    };
  }, [pathname, configChat, jsLoaded, message, asdChatConfig?.openChatWithDeepLink]);

  const handleCloseImageOverlay = () => {
    setImageOverlayOpen(false);
    setImageUrl('');
  };

  const handleBubbleClick = () => {
    setTimeout(() => {
      addDecodedScriptToHead(draggableWidget?.script);
    }, 200);
  };

  const handleWidgetDraggable = () => {
    if (!draggableWidget?.enabled) return;

    widget?.addEventListener('click', () => handleBubbleClick());
  };

  useEffect(() => {
    const isInTeams = checkInTeams();
    if (!widget || !isInTeams || !generalConfig?.teamsAppConfig?.enable) return;

    const handleWidgetClick = (e: Event) => {
      e.stopImmediatePropagation();
      handleNavigateStaticTab(generalConfig?.teamsAppConfig);
    };

    widget.addEventListener('click', handleWidgetClick);

    return () => {
      widget.removeEventListener('click', handleWidgetClick);
    };
  }, [widget, generalConfig?.teamsAppConfig]);

  return (
    <UptimeImageOverlay
      isOpen={imageOverlayOpen}
      dismissable={true}
      imageSrc={imageUrl}
      handleClose={handleCloseImageOverlay}
    />
  );
};

export default ChatWidgetComponent;
